import { APP_NAME } from '~/src/constants';

export default {
  msg_auth_continue: `Continue with ${APP_NAME}`,
  msg_app_tap_to_open: 'Tap to open or download the app.',
  msg_app_open: `Open ${APP_NAME}`,
  msg_app_download: `Download ${APP_NAME}`,
  msg_footer_rights_reserved: `©{{year}} ${APP_NAME}. All rights reserved.`,
} as const;
